const routes = {
  home: '/',
  members: '/members',
  addMember: '/members/add',
  editMember: '/members/edit/:site/:id',
  cdnUpload: '/cdn_upload',
};

export default routes;
